import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiHandle } from "../../config/apiHandle/apiHandle";

export const fetchUserDataAsync = createAsyncThunk(
  "user/fetchUserData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiHandle.post("/me");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Add to your existing extraReducers:
